<script setup>
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import UpgradeButton from '@/components/UpgradeButton.vue';
  import { useMembershipLevels } from '@/composables/useMembershipLevels';

  const props = defineProps({
    upgrade: {
      type: Array,
    required: true
    },
    showProforecastMessaging: {
      type: Boolean,
      default: false
    }
  });

  const { t } = useI18n();
  const { formatMembershipLevels } = useMembershipLevels();

  const messageKeypath = computed(() => props.upgrade[1]?.length === 0 ? 'upgrade.windGraph' : 'upgrade.windGraphWithLevels');
  const formattedLevels = computed(() => props.upgrade[1]?.length ? formatMembershipLevels(props.upgrade[1]) : '');

  const secondaryMessageText = computed(() => {
    return t('upgrade.proForecastPitch');
  });

  const buttonText = computed(() => {
    if (props.upgrade[2] === null) return t('upgrade.upgradeNow');

    return props.upgrade[2] ? t('upgrade.startFreeTrial') : t('upgrade.upgradeNow');
  });
</script>

<template>
  <div class="jwx-upgrade-container-wrapper">
    <div class="jwx-upgrade-container">
      <div class="jwx-upgrade-container__block"></div>
      <div class="jwx-upgrade-container__message">
        <i18n-t :keypath="messageKeypath" tag="p" scope="global" class="jwx-upgrade-container__text">
          <template #levels><strong>{{ formattedLevels }}</strong></template>
          <template #graphName><strong>{{ t('upgrade.windGraphName') }}</strong></template>
        </i18n-t>
        <p 
          v-if="props.showProforecastMessaging"
          class="jwx-upgrade-container__secondary-text"
          v-html="secondaryMessageText"
        ></p>
        <UpgradeButton :buttonText="buttonText" clickLocation="Wind Graphs Banner" />
      </div>

      <div class="jwx-upgrade-container__hero">
        <img src="../assets/images/upgrade/wind-graph-preview.webp" alt="" class="jwx-upgrade-container__hero-image" />
      </div>
      <div 
        v-if="props.showProforecastMessaging"
        class="jwx-upgrade-container__callout"
      >
        <div class="jwx-upgrade-container__callout-graphic">
          <img src="../assets/images/upgrade/wind-graph-pro-forecast-preview.webp" alt="" class="jwx-upgrade-container__callout-image" />
        </div>
        <p class="jwx-upgrade-container__callout-text">{{ t('containers.windGraphs.proForecastModel') }}</p>
      </div>
    </div>

    <img src="../assets/images/upgrade/wind-graph-blurred.jpg" alt="" class="jwx-upgrade-container__bg-image" />
  </div>
</template>